import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CrudService } from '.';
import { GenericResponse, MenuFuncion, SearchMenuFuncionRequestDto, MenuFuncionTenant, SaveMenuFuncionDto } from '../model/index';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})

export class MenuFuncionService extends CrudService<MenuFuncion, number, SaveMenuFuncionDto, SearchMenuFuncionRequestDto> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http, 'menuFuncion', sharedFunctions);
  }

  checkMenu(p: string): Observable<GenericResponse<boolean>> {
    return this._http.get<GenericResponse<boolean>>(this._serviceUrl + '/check-menu/'+p, this.httpOptions);
  }
  checkMenuPadre(p: string): Observable<GenericResponse<string[]>> {
    return this._http.get<GenericResponse<string[]>>(this._serviceUrl + '/check-menu/padre/'+p, this.httpOptions);
  }

  getMenuTenantsById(id: number): Observable<GenericResponse<MenuFuncionTenant[]>> {
    return this._http.get<GenericResponse<MenuFuncionTenant[]>>(this._serviceUrl + '/' + id + '/tenants', this.httpOptions);
  }

  getByTenant(): Observable<GenericResponse<MenuFuncion[]>> {
    return this._http.get<GenericResponse<MenuFuncion[]>>(this._serviceUrl + '/tenant', this.httpOptions);
  }
}
